// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.private {
  border-left: 8px solid #ef7521 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/chat-modal/chat-modal.component.scss"],"names":[],"mappings":"AAAA;EACE,yCAAA;AACF","sourcesContent":[".private {\r\n  border-left: 8px solid #ef7521 !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
